/* eslint-disable import/no-unresolved */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable no-param-reassign */
import { DeliveryDetailsType } from '@/types/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeliveryState {
  delivery: DeliveryDetailsType | null;
  toggleDelivery: boolean;
  deliveryName: string;
}

const initialState: DeliveryState = {
  delivery: null,
  deliveryName: '',
  toggleDelivery: false,
};

const cartSlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    addDeliveryDetails: (
      state: DeliveryState,
      { payload }: PayloadAction<DeliveryDetailsType>,
    ) => {
      state.delivery = payload;
    },
    clearDeliveryDetails: (state: DeliveryState) => {
      state.delivery = null;
    },
    toogleDeliveryState: (
      state: DeliveryState,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.toggleDelivery = payload;
    },
    setDeliveryName: (state, action) => {
      state.deliveryName = action.payload;
    },
  },
});

export const {
  clearDeliveryDetails,
  addDeliveryDetails,
  toogleDeliveryState,
  setDeliveryName,
} = cartSlice.actions;

export default cartSlice.reducer;
